// extracted by mini-css-extract-plugin
export default {"game_board_List":"game-board_game_board_List__LXlN6"};